import { Injectable } from '@angular/core';
import { TokenStorageService } from 'src/app/shared/token-storage';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private user: any = null;

  showNavigationMain: boolean = false;
  showFilter: boolean = false;
  
  constructor(private tokenStorage: TokenStorageService) {
  }

  getUser() {
    return this.tokenStorage.getUser();
  }
  setUser(data) {
    this.user = data
  }
  public formatted(price: any) {
    let formattedPrice = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      // currencyDisplay: "symbol",
    }).format(parseFloat(`${price}`.replace(',', '.')));
    return formattedPrice;
  }
}
